import {useParams} from 'react-router-dom';

import {Leaderboard} from '../../components';

export const ContestLeaderboard = () => {
  const {id, groupContest} = useParams();

  return <Leaderboard contestId={Number(id)} groupContestId={Number(groupContest)} />;
};
